import { useState } from "react";
import { toast } from "sonner";
import { FileText } from "lucide-react";
import api, { errMsg } from "@/lib/api";

export function ShareReport({ kind, reportingDate, plantId, customerId, sectionId, area, label = "PDF" }) {
  const [busy, setBusy] = useState(false);
  const params = { reporting_date: reportingDate, plant_id: plantId || undefined, customer_id: customerId || undefined, section_id: sectionId || undefined, area: area || undefined };
  const pdf = async () => {
    setBusy(true);
    try { const res = await api.get(`/reports/${kind}/pdf`, { params, responseType: "blob" }); const url = URL.createObjectURL(res.data); const a = document.createElement("a"); a.href = url; a.download = `${kind.toUpperCase()}_${reportingDate}.pdf`; a.click(); URL.revokeObjectURL(url); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return <button className="pp-btn-ghost h-9 px-3" onClick={pdf} disabled={busy} data-testid={`share-pdf-${kind}`}><FileText size={14} /> {busy ? "Building…" : label}</button>;
}
